import apiClient from '../api';

// Create a new reminder
export const createReminder = (data, header) => apiClient.post('/reminders', data, header);

// Get all reminders with pagination and filters
export const getAllReminders = (params = {}, header) => {
    const queryParams = new URLSearchParams();
    
    queryParams.append('organizationId', params.organizationId)
    // Add pagination params
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    
    // Add filter params
    if (params.search) queryParams.append('search', params.search);
    
    if (params.isCompleted !== undefined) queryParams.append('isCompleted', params.isCompleted);
    
    // Add sorting params
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/reminders?${queryString}` : '/reminders';
    
    return apiClient.get(url, header);
};

// Get a single reminder by ID
export const getReminderById = (id, header) => apiClient.get(`/reminders/${id}`, header);

// Update a reminder
export const updateReminder = (id, data, header) => apiClient.put(`/reminders/${id}`, data, header);

// Delete a reminder
export const deleteReminder = (id, header) => apiClient.delete(`/reminders/${id}`, header);

// Mark reminder as completed
export const markReminderCompleted = (id, data, header) => apiClient.patch(`/reminders/${id}/complete`, data, header);

// Mark reminder as incomplete
export const markReminderIncomplete = (id, data, header) => apiClient.patch(`/reminders/${id}/incomplete`, data, header);

// Toggle star status
export const toggleStarReminder = (id, header) => apiClient.patch(`/reminders/${id}/star`, header);

// Toggle archive status
export const toggleArchiveReminder = (id, header) => apiClient.patch(`/reminders/${id}/archive`, header);

// Get upcoming reminders
export const getUpcomingReminders = (limit = 10, header) => apiClient.get(`/reminders/upcoming?limit=${limit}`, header);

// Get overdue reminders
export const getOverdueReminders = (params = {}, header) => {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/reminders/overdue?${queryString}` : '/reminders/overdue';
    
    return apiClient.get(url, header);
};

// Get reminders statistics
export const getRemindersStats = (header) => apiClient.get('/reminders/stats', header);
